export var MAX_RADIUS = 225;
export var RADIUS_DIFFERENCE = 25;
